import { ChevronRight } from "lucide-react";

import { Button } from "@/components/button";

import type { MBCUIMessage } from "../types/mbc-chat.types";
import type { MbcUploadBinding } from "./parts/UploadPromptPart";

import { MBCChatInput } from "./MBCChatInput";
import { MBCMessageList } from "./MBCMessageList";

type MBCChatPanelProps = {
  canReview?: boolean;
  isStreaming: boolean;
  messages: MBCUIMessage[];
  onAttach?: () => void;
  onReview: () => void;
  onSelectChoice: (label: string) => void;
  onSend: (text: string) => void;
  status: string;
  /** What the in-chat upload block needs to write the brief. */
  upload?: MbcUploadBinding;
};

export function MBCChatPanel({
  canReview = false,
  isStreaming,
  messages,
  onAttach,
  onReview,
  onSelectChoice,
  onSend,
  status,
  upload,
}: MBCChatPanelProps) {
  const isInputDisabled = status !== "ready";

  return (
    <section className="flex min-h-0 flex-1 flex-col rounded-2xl border border-border-secondary bg-bg-secondary">
      <h2 className="px-3xl pt-xl text-center text-lg font-bold text-text-primary">
        Let&apos;s build your brief together
      </h2>
      <MBCMessageList
        isInteractiveDisabled={isInputDisabled}
        isStreaming={isStreaming}
        messages={messages}
        onReview={onReview}
        onSelectChoice={onSelectChoice}
        upload={upload}
      />
      {canReview ? (
        <div className="border-t border-border-secondary px-3xl py-md">
          <Button
            className="w-full gap-sm"
            onPress={onReview}
            variant="primary"
          >
            Let&apos;s review the brief!
            <ChevronRight className="size-4" />
          </Button>
        </div>
      ) : null}
      <MBCChatInput
        isDisabled={isInputDisabled}
        onAttach={onAttach}
        onSend={onSend}
      />
    </section>
  );
}
